import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {authGuard} from './auth/auth.guard';
import {userViewConfigGuard} from './guards/user-view-config.guard';
import {RouterActions} from '@adnova/jf-ng-components';
import {AppNavigationComponent} from './modules/pages/app-navigation/app-navigation.component';
import {NavigationLink} from './modules/pages/app-navigation/navigation-link.interface';
import {UserViewConfigComponent} from './modules/routes/user-view-config/user-view-config.component';
import {InitPageComponent} from './modules/routes/init-page/init-page.component';


const navigationLinks: NavigationLink[] = [
  {
    label: 'Übersicht', // INFO: Label für die Übersicht.
    iconName: 'dashboard', // INFO: Icon für die Übersicht.
    route: 'overview' // INFO: Router-Link für die Übersicht.
  },
  {
    label: 'Wetter',
    iconName: 'weather',
    route: 'weather'
  },
  {
    label: 'Agrarcharts',
    iconName: 'chart',
    route: 'agrarcharts',
  },
  {
    label: 'News',
    iconName: 'messageOpen',
    route: 'news'
  },
];


/** INFO:
 * Die BetriebsauswahlPage muss über der Ebene der Routes liegen,
 * in der Sie eingebunden sein soll, um nicht bei jedem Navigationsschritt neu geladen zu werden.
 */

const routes: Routes = [
  {
    path: '',
    redirectTo: 'init-page',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [authGuard, userViewConfigGuard],
    loadComponent: () => import('./modules/pages/app-navigation/app-navigation.component').then(m => m.AppNavigationComponent),
    data: {
      redirectAllowed: false,
      navigationLinks,
      buttonLabel: 'Bearbeiten',
      buttonAction: RouterActions.navigateByUrl({url: '/user-view-config'}),
      buttonIcon: 'edit',
      buttonVariant: 'ghost',
    },
    children: [
      {
        path: 'overview',
        loadComponent: () => import('./modules/routes/overview/overview.component').then(m => m.OverviewComponent),
      },
      {
        path: 'weather',
        loadComponent: () => import('./modules/routes/weather/weather.component').then(m => m.WeatherComponent),
      },
      {
        path: 'agrarcharts',
        loadComponent: () => import('./modules/routes/agrarcharts/agrarcharts.component').then(m => m.AgrarchartsComponent),
      },
      {
        path: 'news',
        children: [
          {
            path: '',
            loadComponent: () => import('./modules/routes/news/news.component').then(m => m.NewsComponent),
          },
          {
            path: ':newsId',
            data: {
              buttonLabel: 'Zurück',
              buttonAction: RouterActions.navigateBack(),
              buttonIcon: 'arrowLeft',
              buttonVariant: 'ghost',
            },
            loadComponent: () => import('./modules/routes/news-article/news-article.component').then(m => m.NewsArticleComponent),
          },
        ],
      },
    ],
  },
  {
    path: 'user-view-config',
    canActivate: [authGuard, userViewConfigGuard],
    loadComponent: () => import('./modules/routes/user-view-config/user-view-config.component').then(m => m.UserViewConfigComponent),
  },
  {
    path: 'init-page',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/routes/init-page/init-page.component').then(m => m.InitPageComponent),
  },
  {
    path: 'legal/impressum',
    canActivate: [authGuard],
    component: AppNavigationComponent,
    children: [
      {
        path: '',
        data: {
          redirectAllowed: false,
          buttonLabel: 'Zur Übersicht',
          buttonAction: RouterActions.navigateByUrl({url: '/overview'}),
          buttonIcon: 'arrowLeft',
          buttonVariant: 'ghost',
        },
        loadComponent: () => import('./modules/routes/impressum/impressum.component').then(m => m.ImpressumComponent),
      },
    ],
  },
  {
    path: 'legal/disclaimer',
    canActivate: [authGuard],
    component: AppNavigationComponent,
    children: [
      {
        path: '',
        data: {
          redirectAllowed: false,
          buttonLabel: 'Zur Übersicht',
          buttonAction: RouterActions.navigateByUrl({url: '/overview'}),
          buttonIcon: 'arrowLeft',
          buttonVariant: 'ghost',
        },
        loadComponent: () => import('./modules/routes/disclaimer/disclaimer.component').then(m => m.DisclaimerComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'init-page',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        scrollPositionRestoration: 'top',
        preloadingStrategy: PreloadAllModules,
      },
    ),
  ],
  providers: [],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
